enum SituacaoEntrega {
    Orcamento = 1,
    EmProducao = 10,
    EmExecucao = 20,
    SaiuParaEntrega = 30,
    Entregue = 40,
    Cancelado = 99,
}

export default SituacaoEntrega;
